import React from 'react';
import './sectionSubTitle.css';

const SectionSubTitle = ({ text = '', align = 'left' }) => {
  const className = `sectionSubTitle ${align || ''}`;
  return <h4 className={className}>{text}</h4>;
};

export default SectionSubTitle;
